import PerformanceView from './Performance';

export default PerformanceView;
